// extracted by mini-css-extract-plugin
export default {"avatarPic":"userProfile_avatarPic__u98od","cardText":"userProfile_cardText__iXYR7","profileContainer":"userProfile_profileContainer__C9cUz","wordWrap":"userProfile_wordWrap__9z9vg"};